// extracted by mini-css-extract-plugin
module.exports = {"btn_submit":"contact_btn_submit__xR1Q1","half_circle":"contact_half_circle__C1grc","white_circle":"contact_white_circle__sqcqg","ant-input":"contact_ant-input__MTOFP"};